module.exports = __webpack_public_path__ + "static/bimbo_logo-18117714a7fb089cfd90ed75d95adf53.png";